export default {
  name: 'Lead from manual',
  path: '/lead/manual',
  component: () => import('./lead-from-manual.vue')
};
